import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
export function TestimonialsSection() {
  return <section className="bg-paper px-4 py-16 md:py-24" data-id="element-335" data-mp="1rtl51cydai8v">
      <div className="mx-auto max-w-6xl" data-id="element-336" data-mp="1mxcu6br7db7i">
        <SectionHeading eyebrow="What colleagues are saying" title="Feedback from physiotherapists who value structured clinical resources" data-id="element-337" data-mp="1muibaonu7yg7" />
        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-338" data-mp="1dv3mdtnbjvxt">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-line" data-id="element-339" data-mp="18xbsiu345zqz">
              <div className="flex items-center justify-between" data-id="element-340" data-mp="13ztj72l6piig">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-341" data-mp="339ruhiovmrq1">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-342" data-mp="2y9x6po0eei97" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-7 w-7 text-brand-soft" aria-hidden="true" data-id="element-343" data-mp="1y9031lifgnwt" />
              </div>
              <p className="mt-4 font-display text-lg font-extrabold leading-snug text-ink" data-id="element-344" data-mp="1jc91p6p7124k">“{t.headline}”</p>
              <blockquote className="mt-3 text-base leading-relaxed text-muted" data-id="element-345" data-mp="1obllfikrpt2x">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 border-t border-line pt-5" data-id="element-346" data-mp="2c1fxhxx9jdm4">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-brand-light" data-id="element-347" data-mp="2gxwl8r0jvpyo" />
                <div data-id="element-348" data-mp="2783lqodon1as">
                  <p className="font-bold text-ink" data-id="element-349" data-mp="277ljnb4c9suy">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-350" data-mp="2uxxyl5y04pv1">
                    {t.role} · {t.country}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>
        <div className="mt-12" data-id="element-351" data-mp="39keiv98nrln2">
          <CtaButton label="I want access to the complete collection" sub="One-time payment of $27 · Instant access" data-id="element-352" data-mp="39jlhknsgxocb" />
        </div>
      </div>
    </section>;
}